import { getConciliationAccountDisplayNumber } from '../../../../../../utils/conciliationAccountDisplay'
import clsx from "clsx"
import { useCallback, useEffect, useMemo } from "react"
import translations from '../../../../../ui/traslation/traslationAdministracion.json'
import { formatCurrency, formatDate } from "../../../../../../utils/formatter"
import { Text } from "../../../../../ui"
import imgDefaultBank from '../../../../../../../assets/iconos/iconCasa.png'
import { getConciliationDisplayStatus } from '../../../../../../utils/conciliationStatus'

const TableCajaPrincipal = ({onCheckboxChange,rows, dataLinkage,selectedDataByOrigen,setSelectedDataByOrigen, dataModal,selectedBankFilter, useCajaPrincipal,modalStatus,onCurrentData,dataLinkagePre,tipoLibro,selectedCheckboxes,setSelectedCheckboxes,setSelectedIds,unselectedIds,setUnselectedIds}) => {
  const currentDataLinkage = tipoLibro === 'previred' ? dataLinkagePre : dataLinkage
  const cajaLinkage = Array.isArray(currentDataLinkage)
    ? currentDataLinkage.find(item =>
        [item?.nombreCuentaBanco, item?.nombreBanco, item?.name]
          .some(value => String(value ?? '').trim().toLowerCase() === 'caja principal')
      )
    : null
  const cajaLinkageIds = [cajaLinkage?.id, cajaLinkage?.idPrincipal]
    .filter(id => id != null)
    .map(String)
  const isCajaExplicitlyUnselected = (unselectedIds || [])
    .some(id => cajaLinkageIds.includes(String(id)))
  const isCheckboxChecked = id =>
    !isCajaExplicitlyUnselected &&
    (selectedCheckboxes[id] === true || (id === 'custom-caja-principal' && !!cajaLinkage))

  const handleCheckboxToggle = id => {
    if (useCajaPrincipal && id !== 'custom-caja-principal') return;

    const wasChecked = isCheckboxChecked(id)
    const updatedSelection = {
      ...selectedCheckboxes,
      [id]: !wasChecked
    };

    const selected = Object.keys(updatedSelection).filter(key => updatedSelection[key]);
    const finalSelection = useCajaPrincipal
      ? updatedSelection['custom-caja-principal']
        ? ['custom-caja-principal']
        : []
      : selected;

    setSelectedCheckboxes(
      useCajaPrincipal
        ? { 'custom-caja-principal': updatedSelection['custom-caja-principal'] }
        : updatedSelection
    );
    setSelectedIds(finalSelection);
    onCheckboxChange(finalSelection);

    if (cajaLinkageIds.length > 0) {
      setUnselectedIds((prev = []) =>
        wasChecked
          ? [...new Set([...prev, ...cajaLinkageIds.map(Number)])]
          : prev.filter(value => !cajaLinkageIds.includes(String(value)))
      )
    }

    let selectedData = rows.filter(row => finalSelection.includes(row.id));

    if (useCajaPrincipal && finalSelection.includes('custom-caja-principal') && extraRow) {
      selectedData = [extraRow];
    }

    onCurrentData(selectedData);
  };

  const obtenerAbreviatura = nombre => {
    return translations.documentosContables[nombre] || nombre;
  };

  const obtenerFechaActual = () => {
    const hoy = new Date();
    const dia = String(hoy.getDate()).padStart(2, '0');
    const mes = String(hoy.getMonth() + 1).padStart(2, '0');
    const anio = hoy.getFullYear();
    return `${anio}-${mes}-${dia}`;
  };

  const isCobro = ['COBRADO', 'POR COBRAR', 'PARCIALMENTE COBRADO'].includes(modalStatus)
  const isPago = ['PAGADO', 'POR PAGAR', 'PARCIALMENTE PAGADO'].includes(modalStatus)
  
  const extraRow = useMemo(() => {
    if (!useCajaPrincipal || !dataModal) return null;

    let monto = '';
    let idRef = '';

    if (tipoLibro === 'liquido') {
      monto = dataModal.montoTotal;
      idRef = dataModal.idLiquido;
    } else if (tipoLibro === 'previred') {
      monto = dataModal.montoNeto;
      idRef = dataModal.idPrevired;
    } else {
      monto = dataModal.montoTotal;
      idRef = dataModal.idPrincipal;
    }
    const montoVinculado = Number(
      cajaLinkage?.montoRelacionado ?? cajaLinkage?.montoTotal ?? cajaLinkage?.monto ?? monto ?? 0
    )
    const origen = 'caja'
    return {
      id: 'custom-caja-principal',
      idPrincipal: cajaLinkage?.idPrincipal,
      comprobante: cajaLinkage?.comprobante,
      idRef,
      fecha: obtenerFechaActual(),
      nombreCuentaBanco: 'Caja Principal',
      numeroCuentaBanco: '1-1-1-1',
      descripcion: ` ${obtenerAbreviatura(dataModal.nombreCuenta)} folio ${dataModal.folio}`,
      montoAbono: isCobro ? montoVinculado : 0,
      montoCargo: isPago ? montoVinculado : 0,
      montoEditable: montoVinculado,
      status: 'PENDIENTE',
      customRow: true,
      _origen: origen,
      _montoRef: monto,
    };
  }, [useCajaPrincipal, dataModal, tipoLibro, isCobro, isPago, cajaLinkage]);

   useEffect(() => {
    if (!extraRow) return;
    const origen = 'caja';
    setSelectedDataByOrigen(prev => {
      const current = prev[origen] || [];
      const currentRow = current[0]
      const isAlreadySynchronized =
        current.length === 1 &&
        currentRow?.id === extraRow.id &&
        currentRow?.montoEditable === extraRow.montoEditable &&
        currentRow?.montoCargo === extraRow.montoCargo &&
        currentRow?.montoAbono === extraRow.montoAbono

      if (isAlreadySynchronized) return prev

      // Caja Principal representa una sola selecciÃ³n lÃ³gica. El linkage real y
      // la fila sintÃ©tica no deben aparecer simultÃ¡neamente en el resumen.
      return { ...prev, [origen]: [extraRow] };
    });
  }, [extraRow?.montoEditable, extraRow?.id]);

   const styles = {
    wrapper: 'overflow-x-auto rounded-3xl shadow-sm',
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-gray-50',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-400 font-medium',
  }

  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Cuenta Corriente', field: 'cuentaCorriente' },
    { col: 'Descripción', field: 'descripción' },
    { col: 'Abono', field: 'abono' },
    { col: 'Cargo', field: 'cargo' },
    { col: 'Status', field: 'status' },
    { col: '', field: null},
  ]

  const sortRows = useCallback(() => {
    if (useCajaPrincipal && extraRow) return [extraRow]

    if (!Array.isArray(rows)) return []

    if (currentDataLinkage && currentDataLinkage.length > 0) {
      const match = rows.find(row => row.comprobante === currentDataLinkage[0].comprobante)
      return match ? [match] : []
    }

    return rows
  }, [useCajaPrincipal, extraRow, rows, currentDataLinkage])

    useEffect(() => {
      if (useCajaPrincipal && extraRow) {
        // Evitar loop: solo marcar si aún no está seleccionado
        if (!isCheckboxChecked('custom-caja-principal') && !isCajaExplicitlyUnselected) {
          handleCheckboxToggle('custom-caja-principal');
        }
      } else if (!useCajaPrincipal) {
        setSelectedCheckboxes({});
        setSelectedIds([]);
        onCheckboxChange([]);
        onCurrentData([]);
      }
    }, [useCajaPrincipal])

useEffect(() => {
  if (!rows || rows.length === 0) return;

  const autoSelected = rows.reduce((acc, item) => {
    const shouldBeSelected =
      item.seleccionado === true ||
      (tipoLibro === 'previred'
        ? item.linkagePrevired?.idPrincipal === currentDataLinkage?.[0]?.idPrincipal
        : item.linkage?.idPrincipal === currentDataLinkage?.[0]?.idPrincipal);

    if (shouldBeSelected) acc[item.id] = true;
    return acc;
  }, {});

  // Solo actualizar si hay nuevos seleccionados o si está vacío
  setSelectedCheckboxes((prev) => {
    // Si ya hay alguno marcado, respetamos los cambios del usuario
    if (Object.keys(prev).length > 0) return prev;

    // Inicializamos marcados
    const filtered = Object.fromEntries(
      Object.entries(autoSelected).filter(([id]) => id !== "custom-caja-principal")
    );

    return filtered;
  });
}, [rows, currentDataLinkage, tipoLibro]);

const getCleanStatus = row =>
    typeof row?.status === 'string'
      ? row.status.replace(/\s*undefined\s*/gi, '').trim()
      : ''

const normalizeStatus = status =>
    String(status || '')
      .replace(/\s*undefined\s*/gi, '')
      .trim()
      .toUpperCase()

  const statusTone = status => {
    const s = normalizeStatus(status)
    if (s.includes('PARCIAL')) return 'warning'
    if (s.includes('CONCILIADO') || s.includes('PAGADO') || s.includes('COBRADO')) return 'success'
    if (s.includes('PENDIENTE')) return 'danger'
    if (s.includes('PARCIAL') && s.includes('ANUL')) return 'muted'
    return 'muted'
  }

  const statusBadgeClass = status => {
    const tone = statusTone(status)
    return clsx(
      'inline-flex items-center justify-center px-3 py-1 rounded-full text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider',
      {
        'text-danger bg-danger/10': tone === 'danger',
        'text-success bg-success/10': tone === 'success',
        'text-amber-700 bg-amber-100': tone === 'warning',
        'text-muted bg-border/40': tone === 'muted'
      }
    )
  }

  return (
    <div className="flex flex-col h-full">
      <div className="overflow-x-auto flex-1">
        <div className="max-h-96 overflow-y-auto mt-2">
          <table className={styles.table}>
            <thead className={styles.thead}>
              <tr>
                {orderableCols.map(({ col }, i) => (
                  <th key={i} className={clsx(styles.th, i === 0 && styles.mediumCol)}>
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
           <tbody className={styles.tbody}>
              {sortRows()?.map((item) => {
                const origen = item._origen;
                const currentRows = selectedDataByOrigen[origen] || [];
                const selectedItem = currentRows.find(r => r.id === item.id) || item;
                const cleanStatus = getCleanStatus(item)
                const displayStatus = getConciliationDisplayStatus(
                  cleanStatus,
                  modalStatus,
                  isCheckboxChecked(item.id)
                )
                return (
                  <tr key={item.id} className={styles.tr}>
                    <td className={clsx(styles.td, styles.mediumCol)}>
                      <div className="flex items-center gap-2">
                        <input type="checkbox" className="rounded" checked={isCheckboxChecked(item.id)} onChange={() => handleCheckboxToggle(item.id)}/>
                        <img src={imgDefaultBank} className="h-6 w-auto rounded" />
                      </div>
                    </td>
                    <td className={clsx(styles.td, styles.smallCol)}>
                      <Text className={styles.boldText}>{formatDate(item.fecha)}</Text>
                    </td>
                    <td className={clsx(styles.td, styles.wideCol)}>
                      <Text className={styles.boldText}>{item.nombreCuentaBanco}</Text>
                      <Text className={styles.text}>{getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco)}</Text>
                    </td>
                    <td className={clsx(styles.td, styles.wideCol)}>
                      <Text className={styles.boldText}>{item.descripcion}</Text>
                    </td>
                    <td className={clsx(styles.td, styles.mediumCol)}>
                      {selectedItem.customRow && isCobro ? (
                        <input
                          type="text"
                          inputMode="numeric"
                          className="border rounded-full text-xs text-right px-1 py-0.5 w-20
                            [appearance:textfield]
                            [&::-webkit-outer-spin-button]:appearance-none
                            [&::-webkit-inner-spin-button]:appearance-none"
                          // mostramos montoEditable para permitir edición en el modal/tbl; si no existe, mostramos montoAbono o 0
                          value={`$ ${Number(selectedItem.montoEditable ?? selectedItem.montoAbono ?? 0).toLocaleString('es-CL')}`}
                          onFocus={e => {
                            // al enfocar mostramos el número crudo para editar
                            e.target.value = String(selectedItem.montoEditable ?? selectedItem.montoAbono ?? 0)
                          }}
                          onBlur={e => {
                            // formatea al perder foco (opcional)
                            const digits = e.target.value.replace(/[^\d]/g, '');
                            e.target.value = `$ ${Number(digits || 0).toLocaleString('es-CL')}`
                          }}
                          onChange={e => {
                            const digits = e.target.value.replace(/[^\d]/g, '');
                            const newValue = Number(digits || 0);
                            const origen = selectedItem._origen;

                            setSelectedDataByOrigen(prev => {
                              const current = prev[origen] || [];
                              const updated = current.map(r =>
                                r.id === selectedItem.id
                                  ? {
                                      ...r,
                                      montoEditable: newValue, // valor editable compartido
                                      montoAbono: newValue,    // actualizamos sólo abono
                                      montoCargo: 0,           // y dejamos cargo en 0 (como pides)
                                    }
                                  : r
                              );
                              return { ...prev, [origen]: updated };
                            });
                          }}
                        />
                      ) : (
                        <Text className={styles.boldText}>{formatCurrency(selectedItem.montoAbono)}</Text>
                      )}
                    </td>
                    <td className={clsx(styles.td, styles.mediumCol)}>
                      {selectedItem.customRow && isPago ? (
                        <input
                          type="text"
                          inputMode="numeric"
                          className="border rounded-full text-xs text-right px-1 py-0.5 w-20
                            [appearance:textfield]
                            [&::-webkit-outer-spin-button]:appearance-none
                            [&::-webkit-inner-spin-button]:appearance-none"
                          value={`$ ${Number(selectedItem.montoEditable ?? selectedItem.montoCargo ?? 0).toLocaleString('es-CL')}`}
                          onFocus={e => {
                            e.target.value = String(selectedItem.montoEditable ?? selectedItem.montoCargo ?? 0)
                          }}
                          onBlur={e => {
                            const digits = e.target.value.replace(/[^\d]/g, '');
                            e.target.value = `$ ${Number(digits || 0).toLocaleString('es-CL')}`
                          }}
                          onChange={e => {
                            const digits = e.target.value.replace(/[^\d]/g, '');
                            const newValue = Number(digits || 0);
                            const origen = selectedItem._origen;

                            setSelectedDataByOrigen(prev => {
                              const current = prev[origen] || [];
                              const updated = current.map(r =>
                                r.id === selectedItem.id
                                  ? {
                                      ...r,
                                      montoEditable: newValue, // compartido para modal
                                      montoCargo: newValue,    // actualizamos sólo cargo
                                      montoAbono: 0,           // y dejamos abono en 0
                                    }
                                  : r
                              );
                              return { ...prev, [origen]: updated };
                            });
                          }}
                        />
                      ) : (
                        <Text className={styles.boldText}>{formatCurrency(selectedItem.montoCargo)}</Text>
                      )}
                    </td>
                    <td className={clsx(styles.td, styles.mediumCol)}>
                      <span className={statusBadgeClass(displayStatus)}>
                        {displayStatus || '—'}
                      </span>
                    </td>
                    <td className={clsx(styles.td, styles.mediumCol)}>
                      
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default TableCajaPrincipal
